import { useQuery } from '@tanstack/react-query';
import { compare } from 'compare-versions';

export const useIosAppVersion = () => {
  const appVersionQuery = useQuery({
    queryKey: ['iosAppVersion'],
    queryFn: () => localStorage.getItem('ios_app_version'),
  });

  return appVersionQuery;
};

export const useFeatureOnIos = (featureVersion: string) => {
  const { data: appVersion, isSuccess } = useIosAppVersion();

  if (!isSuccess) {
    return false;
  }

  if (window.webkit && !appVersion) {
    // if we are on ios and we don't have a version storet, we assume we are on an older version that is not supported
    return false;
  }

  if (!appVersion) {
    // For clients that are not in the ipad app we don't have a version number, and for those we should allow all these features.
    return true;
  }

  return compare(appVersion, featureVersion, '>=');
};
